import React from "react";
import "./InvitationDivider.css";

type Tone = "wine" | "cream";

export default function InvitationDivider({ from = "wine", to = from }: { from?: Tone; to?: Tone }) {
  return (
    <div className={`invitation-divider invitation-divider--${from}-to-${to}`} aria-hidden="true">
      <svg className="invitation-divider__monogram" viewBox="-190 60 640 65" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false">
        <path d="M-180 99H20C44 99 65 109 94 98" />
        <path d="M95 106c0-11 4-31 10-30 5 1-3 16-9 22m0 8c3-10 7-18 10-15 2 3-2 13 2 16 6 5 19 2 27-3" strokeWidth="2.8" />
        <path d="M135 105c-7-5-13-13-9-18 4-5 9 0 10 4 2-5 7-9 10-4 4 8-5 17-11 18 10 7 23 5 32-5" />
        <path d="M167 101c5-8 14-24 10-25-5-2-11 17-11 28 0 13 7 3 11-5" strokeWidth="2.8" />
        <path d="M177 99c4-10 35 3 54-5 14-4 25 5 43 5H440" />
      </svg>
    </div>
  );
}
